import { Component, OnInit, Input, forwardRef, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, Validators, AbstractControl, FormGroup, FormArray, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ag-claims',
  templateUrl: './ag-claims.component.html',
  styleUrls: ['./ag-claims.component.css', '../../quote.component.css'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AgClaimsComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => AgClaimsComponent), multi: true }
  ]
})
export class AgClaimsComponent implements OnInit {
  frmFields: FormGroup;
  @Input() submitted: boolean;
  @Input() staticData;
  @Input() modelObj;
  @Input() driver_id;
  @Input() is_claims_selected;
  subscriptions: Subscription[] = [];

  constructor(private fb: FormBuilder, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void { }

  onChange: any = () => { };
  onTouched: any = () => { };
  registerOnChange(fn) { this.onChange = fn; }
  writeValue(value) { }
  registerOnTouched(fn) { this.onTouched = fn; }
  validate(_: FormControl) { return this.frmFields.valid ? null : { drivers: { valid: false } }; }

  get f(): { [key: string]: AbstractControl } { return this.frmFields.controls; }
  get claimsArr(): FormArray { return this.frmFields.get("claims") as FormArray; }

  ngOnChanges(changes: SimpleChanges) {
    this.frmFields = this.fb.group({ claims: this.fb.array([]) });
    this.subscriptions.push(
      this.frmFields.valueChanges.subscribe(value => { this.onChange(value); this.onTouched(); })
    );

    if (this.driver_id && this.modelObj && this.modelObj.drivers && this.modelObj.drivers.length > 0) {
      let driver_claims = this.modelObj.drivers.filter(x => x.id == this.driver_id);
      if (driver_claims.length > 0 && driver_claims[0].claims) {
        this.claimsArr.clear();
        driver_claims[0].claims.forEach((res1) => {
          let c = this.fb.group({
            date: [res1.date, [Validators.required]], type: [res1.type, [Validators.required]],
            ad_cost: [res1.ad_cost, [Validators.required]], tp_cost: [res1.tp_cost, [Validators.required]],
            fault: [res1.fault, [Validators.required]], open: [res1.open, [Validators.required]],
          });
          this.claimsArr.push(c);
        })
      }
    }
  }

  ngAfterViewInit(): void { this.cdRef.detectChanges(); }

  initClaims() {
    return this.fb.group({
      'date': ['', [Validators.required]], 'type': ['', [Validators.required]],
      'ad_cost': ['', [Validators.required]], 'tp_cost': ['', [Validators.required]],
      'fault': ['', [Validators.required]], 'open': ['', [Validators.required]],
    });
  }

  addClaims() { this.claimsArr.push(this.initClaims()); }
  removeClaims(i) { this.claimsArr.removeAt(i); }
  onSubmit() { this.submitted = true; if (!this.frmFields.valid) { return false; } }
}
